"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var responsiveStyles_1 = __importDefault(require("./responsiveStyles"));
var helpers_1 = require("../helpers");
var mixinStyles = function (mixin) {
    if (!mixin)
        return {};
    var mixinKeys = Object.keys(mixin);
    var styles = mixinKeys.reduce(function (res, key) {
        var value = mixin[key];
        return __assign(__assign({}, res), (0, responsiveStyles_1.default)(value, "mixin", (0, helpers_1.toKebabCase)(key)));
    }, {});
    return styles;
};
exports.default = mixinStyles;
